<template>
    <el-dialog
        :title="'园区预约'"
        :width="'1300px'"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'performanceDispatchParkAppointDialog'"
    >
        <template #title>
            <span class="dialog-title">园区预约</span>
            <span class="addition-info">{{ additionInfo }}</span>
        </template>
        <el-tabs v-model="activeName">
            <el-tab-pane label="装货信息" name="load">
                <dispatch-park-appoint-load
                    :activeName="activeName"
                    :rowData="componentsData"
                    :tableData="loadTableData"
                    :disabledSelectable="disabledLoad"
                    @setReservationTime="handleSetReservationTime"
                    @setRadioList="handleSetRadioList"
                    @reset="handleReset"
                    ref="load"
                ></dispatch-park-appoint-load>
            </el-tab-pane>
            <el-tab-pane label="卸货信息" name="unload">
                <dispatch-park-appoint-unload
                    :activeName="activeName"
                    :rowData="componentsData"
                    :tableData="unloadTableData"
                    :disabledSelectable="disabledUnload"
                    @setReservationTime="handleSetReservationTime"
                    @setRadioList="handleSetRadioList"
                    @reset="handleReset"
                    ref="unload"
                ></dispatch-park-appoint-unload>
            </el-tab-pane>
        </el-tabs>
        <template #footer>
            <div>
                 <el-button
                    type="primary"
                    v-if="activeName === 'load'"
                    :loading="reservationSequenceLoading"
                    :disabled="!loadTableData.length"
                    @click="handleReservationSequence"
                    >更新装车排序</el-button>
            </div>
            <div>
                <el-button :loading="cancelBtnLoading" @click="handleCancel">取消预约</el-button>
                <!-- <el-button
                    type="primary"
                    :loading="updateBtnLoading"
                    @click="handleUpdate"
                    >更新</el-button
                > -->
                <el-button
                    type="primary"
                    :loading="confirmBtnLoading"
                    @click="handleSubmit"
                    >确定</el-button
                >
            </div>
        </template>
    </el-dialog>
</template>
<script>
import DispatchParkAppointLoad from './DispatchParkAppointLoad.vue';
import DispatchParkAppointUnload from './DispatchParkAppointUnload.vue';
import { queryReservationLoadInfo, reservationUpdate, reservationConfirm, reservationCancel, reservationSequence  } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import { dealWithSubmitParams, validateSubmitParams, formatList, validateConfirmParams, dealWithCancelParams } from './util.js';
export default {
    name: 'performanceDispatchParkAppointDialog',
    components: {
        DispatchParkAppointLoad,
        DispatchParkAppointUnload
    },
    props: {
        parkApponitVisiable: {
            type: Boolean,
            default: false
        },
        componentsData: {
            type: Object,
            default () { return {}; }
        }
    },
    data () {
        return {
            cancelBtnLoading: false, // 取消预约加载动画
            confirmBtnLoading: false, // 确定按钮加载动画
            updateBtnLoading: false, // 更新按钮加载动画
            reservationSequenceLoading: false, // 更新装车排序加载动画
            visible: false, // 是否显示弹窗
            activeName: 'load', // 当前标签页
            info: {}, // 存放整个预约信息
            loadTableData: [], // 装货信息列表
            unloadTableData: [] // 卸货信息列表
        };
    },
    computed: {
        additionInfo () { // 弹窗标题附加信息
            const { dispatchNo, driver, vehicleCard, driverContactWay } = this.componentsData;
            return dispatchNo + ' / ' + driver + ' / ' + vehicleCard + ' / ' + driverContactWay;
        },
        // 装货预约能力 发车单状态为在途之前
        disabledLoad () {
            return this.info.loadFlag === 'Y' && +this.componentsData.dispatchStatus < 40;
        },
        // 卸货预约能力
        disabledUnload () {
            return this.info.unLoadFlag === 'Y';
        }
    },
    methods: {
        /**
         * @description 获取装货、卸货列表
         */
        getList () {
            this.$refs[this.activeName].loading = true;
            queryReservationLoadInfo({
                dispatchNo: this.componentsData.dispatchNo
            }).then(res => {
                if (res && +res.code === 0) {
                    this.loadTableData = formatList(res.data.loadWhList || []);
                    this.unloadTableData = formatList(res.data.unloadWhList || []);
                    this.info = res.data;
                }
            }).finally(() => {
                this.$refs[this.activeName].loading = false;
            });
        },

        getCurrentTableData () {
            return this.activeName === 'load' ? this.loadTableData : this.unloadTableData;
        },

        /**
         * @description 设置选中的预约时间
         * @param {Number} index 当前选中的表格数据索引
         * @param {String} date 选中的日期 + 具体时间点
         */
        handleSetReservationTime ({ index, date }) {
            const tableData = this.getCurrentTableData();
            tableData[index].reservationTime = date;
        },

        /**
         * @description 设置radioList
         * @param {Number} index 当前选中的表格数据索引
         * @param {Array} list 具体时间点列表数据
         */
        handleSetRadioList ({ index, list, lineInfo, abilityTimeCodesCurrent, overFlag }) {
            const tableData = this.getCurrentTableData();
            tableData[index].radio = -1;
            tableData[index].radioList = list;
            tableData[index].lineInfo = lineInfo;
            tableData[index].abilityTimeCodesCurrent = abilityTimeCodesCurrent;
            tableData[index].overFlag = overFlag;
        },

        /**
         * @description 重置数据
         * @param {Number} rowIndex 当前选中的表格数据索引
         */
        handleReset (data) {
            const tableData = this.getCurrentTableData();
            // 处理全选
            if (Array.isArray(data)) {
                const rowIndexData = data.map(v => v.rowIndex);
                for (const rowIndex of rowIndexData) {
                    this.reset(tableData, rowIndex);
                }
            } else {
                const { rowIndex } = data;
                this.reset(tableData, rowIndex);
            }
        },

        // 重置项
        reset (tableData, rowIndex) {
            tableData[rowIndex].reservationTime = tableData[rowIndex].originReservationTime;
            tableData[rowIndex].bookingDate = '';
            tableData[rowIndex].radio = -1;
            tableData[rowIndex].loading = false;
            tableData[rowIndex].radioList = [];
            tableData[rowIndex].lineInfo = {};
            tableData[rowIndex].abilityTimeCodesCurrent = [];
            tableData[rowIndex].overFlag = '';
        },

        // 更新
        handleUpdate () {
            this.updateBtnLoading = true;
            const params = {
                bookingType: this.activeName === 'load' ? 0 : 10, // 装货|卸货【0：装货, 10: 卸货】
                dispatchNo: this.componentsData.dispatchNo,
                loadWhCodeList: this.info.loadWhCodeList,
                unloadDistributionWhCodeList: this.info.unloadDistributionWhCodeList,
                unloadWhCodeList: this.info.unloadWhCodeList
            };
            reservationUpdate(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('园区预约更新成功！');
                    this.beforeClose();
                }
            }).finally(() => { this.updateBtnLoading = false; });
        },

        // 确定
        handleSubmit () {
            const multipleSelection = this.$refs[this.activeName].multipleSelection;
            const isTrue = validateSubmitParams(multipleSelection);
            if (!isTrue) return;
            this.confirmBtnLoading = true;
            const params = dealWithSubmitParams(multipleSelection, this.componentsData);
            params.bookingType = this.activeName === 'load' ? 0 : 10; // 装货|卸货【0：装货, 10: 卸货】
            reservationConfirm(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('仓库预约时间段成功！');
                    this.beforeClose();
                }
            }).finally(() => { this.confirmBtnLoading = false; });
        },

        // 取消预约
        handleCancel () {
            const multipleSelection = this.$refs[this.activeName].multipleSelection;
            const isTrue = validateConfirmParams(multipleSelection);
            if (!isTrue) return;
            const params = dealWithCancelParams(multipleSelection, this.componentsData, this.activeName);
            this.cancelBtnLoading = true;
            reservationCancel(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('取消预约成功！');
                    this.beforeClose();
                }
            }).finally(() => { this.cancelBtnLoading = false; });
        },
        handleReservationSequence () {
            this.reservationSequenceLoading = true;
            reservationSequence(this.getCurrentTableData()).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('更新装车排序成功！');
                    this.getList();
                    this.$refs[this.activeName].multipleSelection = [];
                }
            }).finally(() => { this.reservationSequenceLoading = false; });
        },
        // 关闭
        beforeClose () {
            this.$emit('components-close');
        }
    },
    mounted () {
        this.visible = true;
        this.$nextTick(() => {
            this.getList();
        });
    }
};
</script>
<style lang="less">
.performanceDispatchParkAppointDialog {
    .el-dialog__body {
        padding-top: 0;
    }
    .addition-info {
        color: #00bcbf;
        font-size: 14px;
        margin-left: 25px;
    }
    .performanceDispatchParkAppointTable {
        display: flex;
        justify-content: space-between;
        .leftTable,
        .rightTable {
            width: 50%;
            box-sizing: border-box;
        }
        .leftTable {
            border: 1px solid #ebeef5;
            .el-table--group,
            .el-table--border {
                border: none;
            }
            .el-table--border th:last-child,
            .el-table--border td:last-child {
                border-right: none;
            }
        }
        .rightTable {
            padding-left: 10px;
        }
    }
    .rightTable {
        max-height: 400px;
    }
    .box-card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .el-dialog__footer {
        display: flex;
        justify-content: space-between;
    }
}
</style>
